import { EPage } from '@/shared/enum/page.enum'
import type { RouteRecordRaw } from 'vue-router'
import { ROUTES_GUARDS } from '../mce/guards'

export const routesChatbot: RouteRecordRaw[] = [
  {
    path: '/maintenance',
    component: () => import('@/maintenance/pages/MaintenancePage.vue'),
    name: EPage.MAINTENANCE
  },
  {
    path: '/',
    redirect: '/',
    component: () => import('@/components/layouts/ChatbotLayout.vue'),
    children: [
      {
        path: '',
        name: EPage.BLANK,
        component: () => import('@/blank/BlankPage.vue'),
        beforeEnter: ROUTES_GUARDS[EPage.BLANK]
      },
      {
        path: 'sendRecharges',
        name: EPage.SEND_RECHARGES,
        component: () => import('@/send-recharges/pages/SendRechargesPage.vue')
      },
      {
        path: 'packages',
        name: EPage.PACKAGES,
        component: () => import('@/packages/pages/PackagesPage.vue'),
        beforeEnter: ROUTES_GUARDS[EPage.PACKAGES]
      },
      {
        path: 'result/:folio',
        name: 'okResult',
        component: () => import('@/result/pages/ResultPage.vue')
      },
      {
        path: 'genericError',
        name: EPage.GENERIC_ERROR,
        component: () => import('@/generic-error/pages/GenericErrorPage.vue')
      },
      {
        path: 'terms',
        name: EPage.TERMS,
        component: () => import('@/terms/pages/TermsPage.vue')
      },
      {
        path: '/payForm/:payForm/:folio',
        name: EPage.PAYMENT_FORM,
        component: () => import('@/payment-form/page/PaymentFormPage.vue')
      },
      {
        path: 'invoice',
        name: EPage.INVOICE,
        component: () => {}
      },
      {
        path: '/generateFolio',
        name: EPage.GENERATE_FOLIO,
        component: () => import('@/generate-folio/GenerateFolio.vue')
      },
      {
        path: '/latePayment',
        name: EPage.LATE_PAYMENT,
        component: () => import('@/late-payment/pages/LatePaymentPage.vue')
      },
      {
        path: '/:pathMatch(.*)*',
        name: EPage.NOT_FOUND,
        component: () => import('@/not-found/pages/NotFoundPage.vue')
      }
    ]
  }
]
